<template>
  <v-container>
    <v-row class="d-flex justify-space-between">
      <v-col cols="1">
        <v-avatar color="blue grey">
          <v-icon dark> mdi-poll </v-icon>
        </v-avatar>
      </v-col>
      <v-col class="d-flex align-center">
        <h1 class="text-h5 font-weight-black">Risk Profile</h1>
      </v-col>
      <v-col class="d-flex align-center justify-end">
        <v-tooltip left>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              depressed
              color="blue grey"
              v-bind="attrs"
              v-on="on"
              dark
              :loading="uploadLoading"
              @click="upload"
            >
              <v-icon class="pa-1">mdi-upload</v-icon>
              Upload</v-btn
            >
          </template>
          <span>Upload to SharePoint</span>
        </v-tooltip>
      </v-col>
    </v-row>
    <v-divider class="mt-3" />
    <v-tabs>
      <v-tab>Profile</v-tab>
      <v-tab>History</v-tab>
      <v-tab-item>
        <RiskProfileForm :profileModel="profileModel" />
      </v-tab-item>
      <v-tab-item>
        <RiskHistoryForm :historyModel="historyModel" />
      </v-tab-item>
    </v-tabs>
  </v-container>
</template>

<script>
const siteId = '800a4f4a-767c-474e-a618-5ef116e1aeae'
const listId = '5E491BEC-2BDA-4D1F-9722-1B9FC2497590'
import { postListItems } from '@/services/api/graph/graph.sites.service'
import RiskProfileForm from '@/components/risk/RiskProfileForm'
import RiskHistoryForm from '@/components/risk/RiskHistoryForm'
export default {
  components: {
    RiskProfileForm,
    RiskHistoryForm,
  },

  data() {
    return {
      profileModel: {
        riskNo: null,
        company: null,
        lastUpdate: null,
        initialReport: null,
        adHoc: true,
        currency: null,
        riskResponsible: null,
        riskOwner: null,
        categoryMain: null,
        categorySub: null,
        riskLabel: null,
        riskDescription: null,
      },
      historyModel: [],
      uploadLoading: false,
    }
  },
  computed: {
    postProfile() {
      return [
        {
          fields: {
            RiskNo: this.profileModel.riskNo,
            Company: this.profileModel.company,
            Currency: this.profileModel.currency,
            InitialReporting: this.profileModel.initialReport,
            LastUpdated: this.profileModel.lastUpdate,
            RiskResponsible: this.profileModel.riskResponsible,
            RiskOwner: this.profileModel.riskOwner,
            MainCategory: this.profileModel.categoryMain,
            SubCategory: this.profileModel.categorySub,
            RiskLabel: this.profileModel.riskLabel,
            RiskDescription: this.profileModel.riskDescription,
          },
        },
      ]
    },
  },
  methods: {
    upload() {
      this.uploadLoading = true
      postListItems(siteId, listId, this.postProfile)
        .then((reponse) => {
          console.log(reponse)
        })
        .catch((error) => {
          console.error(error)
        })
        .finally(() => {
          this.uploadLoading = false
        })
    },
  },
}
</script>
